
const BG_transparent = '#1c2237a6';
const BG_transparent_light = '#1d223659';

export {BG_transparent}
export {BG_transparent_light}